import React from "react";
import {IActionResult} from "../../../model/service/dataStorage/ActionsService";
import IContentType from "../../../model/interface/dataStorage/IContentType";
import IBaseProps from "../../../model/interface/IBaseProps";
import ViewUnitsService from "../../../model/service/dataStorage/ViewUnitsService";
import IViewUnit from "../../../model/interface/dataStorage/IViewUnit";
import IViewPermissions from "../../../model/interface/dataStorage/view/IViewPermissions";
import {Col, Row, Tooltip, Typography} from "antd";
import {RightOutlined} from "@ant-design/icons";
import IViewAction from "../../../model/interface/dataStorage/view/IViewAction";
import {ActionButtonExecuteType} from "../action/ActionButton";
import Button from "../../shared/button/Button";
import LocaleText from "../settings/dictionary/LocaleText";
import _ from "underscore";
import RoutesRouter from "../router/RoutesRouter";
import Collapse from "../../shared/display/collapse/Collapse";

interface IState {
}

interface IProps extends IBaseProps {
    onFinish: (result?: IActionResult) => Promise<void>,
    onClick?: (executeAction: ActionButtonExecuteType, viewAction: IViewAction) => Promise<void>
    contentType: IContentType
    permissions: IViewPermissions
    viewUnit: IViewUnit
}

class ViewDirectSchemeActions extends React.Component<IProps, IState> {


    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {viewUnit, permissions, contentType, onFinish} = this.props
        const allowedSchemeActions = ViewUnitsService.getAllowedDirectSchemeActions(viewUnit, permissions, contentType)

        return allowedSchemeActions.length > 0 && (
            <Row className={'w-100'}>

                    {allowedSchemeActions.map(action => {
                        const ctAction = _.findWhere(contentType.actions, {uuid: action.action})

                        return ctAction && (
                            <div className={'w-100 mb-3'} key={action.uuid}>
                                <Collapse collapsed={false} header={(collapsed, triggerCollapse) =>
                                    <Row justify={"space-between"} onClick={() => triggerCollapse()} className={'w-100 cursor-pointer'}
                                         align={"middle"}>
                                        <Tooltip title={action.tooltip ? <LocaleText code={action.tooltip}/> : undefined}>
                                            <Typography.Title level={4} className={'m-0'}>
                                                <LocaleText code={action.label}/>
                                            </Typography.Title>
                                        </Tooltip>
                                        <Row gutter={[6, 6]} justify={"end"}>
                                            <Col>
                                                <Tooltip title={collapsed ? 'rozbalit' : 'sbalit'}
                                                         mouseEnterDelay={1}>
                                                    <Button shape={"circle"} icon={<Row justify={'center'}><RightOutlined/></Row>}
                                                            style={{transform: 'rotate(' + (collapsed ? '0' : '-90') + 'deg)'}}/>
                                                </Tooltip>
                                            </Col>
                                        </Row>
                                    </Row>}>
                                <RoutesRouter path={ctAction.route || ''} directAction={true} onActionFinish={onFinish} isModal={true}/>
                                </Collapse>
                            </div>
                        )
                    })}

            </Row>
        )
    }
}

export default ViewDirectSchemeActions